import React from 'react';
import { IProps } from './type';

const SelectedHomeIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.45935 9.40588C4.25 9.8267 4.25 10.315 4.25 11.2917V18.8732C4.25 19.816 4.25 20.2874 4.54289 20.5803C4.83579 20.8732 5.30719 20.8732 6.25 20.8732H9.71429V15.1589C9.71429 14.0543 10.6097 13.1589 11.7143 13.1589H13.7857C14.8903 13.1589 15.7857 14.0543 15.7857 15.1589V20.8732H19.25C20.1928 20.8732 20.6642 20.8732 20.9571 20.5803C21.25 20.2874 21.25 19.816 21.25 18.8732V11.2917C21.25 10.315 21.25 9.8267 21.0406 9.40588C20.8313 8.98507 20.4418 8.6905 19.6629 8.10137L19.6628 8.10137L13.9564 3.78558C13.3759 3.3465 13.0856 3.12695 12.75 3.12695C12.4144 3.12695 12.1241 3.3465 11.5436 3.78558L5.83715 8.10137C5.05818 8.6905 4.6687 8.98507 4.45935 9.40588Z"
        fill={fillColor ? fillColor : "#212121"} />
    </svg>
  )
};

export default SelectedHomeIcon;
